import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
    this.translateLabels();

    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });
  }

  translateLabels() {
    this.itemsPerPageLabel = this.translate.instant('employee-pagination.itemsPerPage');
    this.nextPageLabel = this.translate.instant('employee-pagination.nextPage');
    this.previousPageLabel = this.translate.instant('employee-pagination.previousPage');

    this.changes.next(); // refresh paginator UI
  }

  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    if (length === 0 || pageSize === 0) {
      return `0 of ${length}`;
    }

    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);

    return `${startIndex + 1} - ${endIndex} ${this.translate.instant('employee-pagination.of')} ${length}`;
  };
}